<div class="section">
    <div class="container">
        <div class="row">
            <div class="col-md-6 col-xs-12">
                <div class="supericon"><img src="../../../../assets/images/ani-logo-v2.svg" /></div>
            </div>
            <div class="col-md-6">
                <h1>404</h1>
                <h2>UH OH! You're lost.</h2>
                <p>
                    The page you are looking for does not exist. How you got
                    here is a mystery. But you can click the button below to go
                    back to the homepage.
                </p>
                <div class="top-but-lay">
                    <div class="small-button">
                        <a href="#" class="primary-btn order-submit">Home</a>
                    </div>
                </div>
            </div>
            <p>&nbsp;</p>
        </div>
    </div>
</div>